module.exports = __webpack_public_path__ + "static/img/img_15.6a77536.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prefecture/images/img_15.webp
// module id = Ihup
// module chunks = 9